import { Avatar, Button, Card, Checkbox, Layout, Segmented, Space, Spin, Table, Tooltip, Typography } from "antd"
import { useContext, useEffect, useState,useRef } from "react"
import FieldsService from "../../services/Fields";
import { DownOutlined, EditOutlined, EllipsisOutlined, ExportOutlined, SettingOutlined } from "@ant-design/icons";
import { Path, StaticGoogleMap } from "../google-js-maps/StaticGoogleMap";
import polyline from 'google-polyline';
import { flattenPolygonCoordinates } from "../../utilities/polygon_util";
import { NavLink } from "react-router-dom";
import { GlobalContext } from "../../App";
import { BaseViewContext } from "../../views/Base";
import { useHorizontalScroll } from "../../utilities/useHorizontalScroll";
import { useTranslation } from "react-i18next";
import EditUserInfoModal from "./EditUserInfoModal";

const TeamTable = (props) => {
  const { t, i18n } = useTranslation("translation");
  const [data_layout, setDataLayout] =  useState("table");
  const [team_data, setTeamData] = useState([]);
  const [filtered_team_data, setFilteredTeamData] = useState([]);
  const [member_fields_data, setMemberFieldsData] = useState({});
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const {setViewLoading, user: currentUser} = useContext(BaseViewContext);

  const {
    setSelectedUserAsset
  } = useContext(GlobalContext);

  useEffect(()=>{
    if(props.data) {
		  setTeamData(props.data);
    }
	}, [props.data])

  useEffect(()=>{
    if(props.filtered_data) {
		  setFilteredTeamData(props.filtered_data);
    }
	}, [props.filtered_data])

  useEffect(()=> {
  
  }, [member_fields_data])

  useEffect(()=> {
    const fetchFieldsByUser = async (user) => {
      setViewLoading(true)
      FieldsService.getAllFields({user: user.id}, _fields => {
      member_fields_data[user.id] = _fields;
      setMemberFieldsData({...member_fields_data})
      setViewLoading(false)
  
      });
      
    }

    if(team_data){
      for(var i = 0; i < team_data.length; i++){
        fetchFieldsByUser(team_data[i])
      }
    }
  }, [team_data])

  const handleEditClick = (member, event) => {
    event?.stopPropagation();
    if (currentUser?.id !== member.id) {
      return;
    }
    setSelectedUser(member);
    setEditModalOpen(true);
  };

  const handleUserUpdated = (updatedUser) => {
    if (!updatedUser) return;
    const updateList = (list) => (list || []).map((item) => (
      item.id === updatedUser.id ? { ...item, ...updatedUser } : item
    ));
    setTeamData(updateList(team_data));
    setFilteredTeamData(updateList(filtered_team_data));
    props.onUserUpdated && props.onUserUpdated(updatedUser);
    setSelectedUser(updatedUser);
  };

  // Column definitions for FieldsComparisonTable, see below.
  const columns = [
    {
      title: t('general.name'),
      dataIndex: 'name',
      className: 'centered-cell text-left-cell',
      width: 220,
      ellipsis: true,
      render: (name, member) => {
        let user_name_avatar = name?.split(" ").length > 1 ? (name?.split(" ")[0][0] + name?.split(" ")[1][0]) : name[0]
          return (  
            <NavLink to={`/team/member/${member.id}`}>
              <Space direction="horizontal" style={{textAlign: "left"}}  className="table-row-clickable-cell">
                <Avatar size="large" style={{ backgroundColor: '#f56a00' }}>{user_name_avatar}</Avatar>
                <Typography.Text className="table-row-clickable-cell-text" ellipsis={{ tooltip: name }}>
                  {name}
                  <sup className="link-to-something"><ExportOutlined /></sup>
                </Typography.Text>
              </Space>
            </NavLink>
          )
      },
    },
    {
      title: t('general.email'),
      dataIndex: 'email',
      className: 'centered-cell',
      width: 220,
      ellipsis: true,
      render: email => {
          return (
            <Typography.Text ellipsis={{ tooltip: email }}>
              {email || "N/A"}
            </Typography.Text>
          )
      },
    }, {
      title: t('components.fields'),
      dataIndex: '',
      className: 'centered-cell',
      width: 240,
      responsive: ['lg'],
      render: (row) => {
        const row_index = row.id;//team_data.indexOf(row)
        //const path = "enc:" + polyline.encode(flattenPolygonCoordinates(member_fields_data[row_index]?.field.geometry.coordinates));
        return (
          <>
            {
              !member_fields_data[row_index] &&
                <Spin />
            }
            <Tooltip title="">
              <Space direction='horizontal' style={{gap: "0 !important"}}>
              
              {
                member_fields_data && member_fields_data[row_index] &&
                  <Avatar.Group shape="square">
                    {
                      member_fields_data[row_index]?.data.slice(0,3).map((field) => (
                        <Avatar shape="square" style={{ backgroundColor: '#f56a00', fontSize: 11}}>
                            {`${field.name[0]}${field.name.split(" ")[1]}`}
                            {/* <StaticGoogleMap size="200x200" maptype="satellite" apiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY}>
                              <Path
                                weight="1"
                                fillcolor='0xFFFF0033'
                                points={path}
                              />
                            </StaticGoogleMap> */}
                        </Avatar>
                      ))
                    }
                    {
                      (member_fields_data[row_index]?.count - 3 > 0) &&
                        <Avatar style={{ backgroundColor: '#f56a00', fontSize: 11}}>
                            +{member_fields_data[row_index].count - 3}
                        </Avatar>
                    }
                  </Avatar.Group>
                }

                
              </Space>
            </Tooltip>
          </>
        )
      },
    },
    {
      title: t('general.phone'),
      dataIndex: 'phoneNumber',
      className: 'centered-cell',
      width: 160,
      responsive: ['sm'],
      ellipsis: true,
      render: (phone, member) => {
          const value = phone || member?.phone || "N/A";
          return (
            <Typography.Text ellipsis={{ tooltip: value }}>
              {value}
            </Typography.Text>
          )
      },
    },{
      title:  t('general.address'),
      responsive: ['xl'],
      children: [
        {
          title: t('general.street'),
          dataIndex: ['address', 'street'],
          className: 'centered-cell',
          width: 180,
          ellipsis: true,
          render: street => {
            return (
              <Typography.Text ellipsis={{ tooltip: street }}>
                {street || "N/A"}
              </Typography.Text>
            )
          },
        },{
          title: t('general.suite'),
          dataIndex: ['address', 'suite'],
          className: 'centered-cell',
          width: 120,
          ellipsis: true,
          render: suite => {
              return (
                <Typography.Text ellipsis={{ tooltip: suite }}>
                  {suite || "N/A"}
                </Typography.Text>
              )
          },
        },{
          title: t('general.city'),
          dataIndex: ['address', 'city'],
          className: 'centered-cell',
          width: 140,
          ellipsis: true,
          render: city => {
            return (
              <Typography.Text ellipsis={{ tooltip: city }}>
                {city || "N/A"}
              </Typography.Text>
            )
          },
        },{
          title:  t('general.zipcode'),
          dataIndex: ['address', 'zipcode'],
          className: 'centered-cell',
          width: 120,
          ellipsis: true,
          render: zipcode => {
            return (
              <Typography.Text ellipsis={{ tooltip: zipcode }}>
                {zipcode || "N/A"}
              </Typography.Text>
            )
          },
        }
      ]
    },
    {
      title: t('general.actions'),
      dataIndex: 'actions',
      className: 'centered-cell',
      width: 80,
      render: (_value, member) => {
        const isSelf = currentUser?.id === member.id;
        return (
          <Tooltip title={isSelf ? t('general.edit') : t('general.only_edit_own_profile')}>
            <Button
              type="text"
              size="small"
              icon={<EditOutlined />}
              disabled={!isSelf}
              onClick={(event) => handleEditClick(member, event)}
            />
          </Tooltip>
        );
      },
    }
  ];

  const horizontal_scroll_ref = useHorizontalScroll();  // Check expandedRowRender below, to be used to scroll fields in expanded table row horizontally

  return (

    <>
      <Table
        sticky
        tableLayout="auto"
        className="team-table"
        rowKey={(record) => record.id}
        style={{cursor: "pointer"}}
        onRow={(record, rowIndex) => {
          return {
              onClick: event => {
              //let basePath = current_view?.basePath ? current_view.basePath : "/" ;
              //navigate(`${basePath}/fields/${record.id}`);
              }, // click row
          };
        }}
        footer={()=> {
          return (
            <Space direction="horizontal"  style={{float: "left"}}>
              <Typography.Text>
                <b>{t('general.total')}:</b> {filtered_team_data?.length} {`${t('general.member')}${filtered_team_data?.length>1 && i18n.language !== "tr" ? "s" : ""}`}
              </Typography.Text>
            </Space>
          )
        }}
        columns={columns}
        scroll={{ x: 'max-content' }}
        expandable={{
          expandedRowRender: (record) => {
            const row_index = record.id;
            return (
              <>
                {
                  !member_fields_data[row_index] &&
                    <Spin />
                }
                <Space direction="horizontal" ref={horizontal_scroll_ref} style={{overflowX: "scroll",  width: "65vw"}}> 
                  {
                    member_fields_data[row_index]?.data.map((_rf, idx) => {
                      // encode the field coordinates for Google Static Map API
                      const path = "enc:" + encodeURIComponent(polyline.encode(flattenPolygonCoordinates(_rf.geometry.coordinates)));
                      return (
                        <NavLink to={`/ndvi/fields/${_rf.id}`}>
                          <Card key={idx}
                            className="data-avatars-card"
                            hoverable
                            style={{ width: 150 }}
                            //onClick={() => onCardClick(field)}
                            cover={
                              <>
                                <StaticGoogleMap size="200x200" maptype="satellite" apiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY}>
                                  <Path
                                    weight="1"
                                    fillcolor='0xFFFF0033'
                                    points={path}
                                  />
                                </StaticGoogleMap>
                              </>
                            }
                          >
                            <Card.Meta title={_rf.name} />
                          </Card>
                        </NavLink>
                      )
                  })
                }
              </Space>
            </> 
          )
          },
          rowExpandable: (record) => record.name !== 'Not Expandable',
          expandRowByClick: true
        }}
        dataSource={filtered_team_data}
        pagination={true}
        bordered
        rowClassName={() => 'table-row'}
      />

      <EditUserInfoModal
        open={editModalOpen}
        user={selectedUser}
        onCancel={() => setEditModalOpen(false)}
        onUserUpdated={handleUserUpdated}
      />
    </>
    
  )
}

export default TeamTable
